import { type UUID } from '~/types/common';

import {
  filter,
  flatMap,
  isPlainObject,
  map,
  pipe,
  unique,
  values,
} from '@vestigas/utils';

import { type DeliveryNoteAdmin } from '../types';

/**
 * Extracts the IDs of the invoices that are referenced in the billing details of the line items of the delivery note.
 * @param deliveryNote - The delivery note to extract the referenced invoice IDs from.
 * @returns An array of unique, valid invoice IDs.
 */
export const getReferencedInvoiceIds = (
  deliveryNote: DeliveryNoteAdmin,
): UUID[] => {
  if (!isPlainObject(deliveryNote?.billedItems)) {
    return [];
  }

  const invoiceIds = pipe(
    deliveryNote?.billedItems,
    values,
    flatMap((billedByPartyItems) => billedByPartyItems ?? []),
    flatMap(({ billingDetails }) => billingDetails ?? []),
    map(({ invoiceUuid }) => invoiceUuid),
    unique,
    filter(Boolean),
  );

  return invoiceIds;
};
